import cookies from 'js-cookie';

const MAX_EXPIRE_DATE = 2147483647e3;
class CookieService {
  read(name) {
    return cookies.get(name);
  }
  write(name, value, options) {
    if (options && options.permanent) {
      options.expires = new Date(MAX_EXPIRE_DATE);
    }
    cookies.set(name, value, options);
  }
}

export { CookieService };
